// extracted by mini-css-extract-plugin
export default {"icon-pos":"StyledMenu_icon-pos__GyWpI","menuitem-text":"StyledMenu_menuitem-text__L64Yn"};